'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./text.scss');

var _withTypography = require('../with-typography');

var _withTypography2 = _interopRequireDefault(_withTypography);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Text(_ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      italic = _ref.italic,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'size', 'italic']);

  var classes = (0, _classnames2.default)('text', 'text--size-' + size, className);

  return _react2.default.createElement(
    'p',
    _extends({ className: classes }, props),
    children
  );
}

Text.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node]),
  className: _propTypes2.default.string,
  italic: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large', 'xx-large'])
};

Text.defaultProps = {
  size: 'medium'
};

exports.default = (0, _withTypography2.default)(Text, { color: 'darkest', weight: 'regular' });